/**
 * Redirección a colección dedicada al aplicar filtro de origen único.
 *
 * Flujo: marca Colombia (único filtro) → pulsa "Aplicar filtros" → /collections/cafe-colombia/
 * Si hay más filtros combinados → comportamiento normal de Shopify.
 */

(function () {

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.facets__submit');
    if (!btn) return;

    var form = btn.closest('form');
    if (!form) return;

    var allChecked = form.querySelectorAll('input[type="checkbox"]:checked');
    var collectionChecked = form.querySelectorAll('input[type="checkbox"][data-collection-url]:checked');
    var rangeInputs = form.querySelectorAll('input[type="number"][name*="filter"], input[type="range"][name*="filter"]');

    var hasRangeActive = Array.prototype.some.call(rangeInputs, function (input) {
      return input.value !== '' && input.value !== input.defaultValue;
    });

    if (collectionChecked.length !== 1) return;
    if (allChecked.length !== 1) return;
    if (hasRangeActive) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = collectionChecked[0].dataset.collectionUrl;
  }, true);

})();
